import React from 'react'
import { observer } from 'mobx-react-lite'
import { CMS } from '@odiupsk/up-api-client'
import Link from 'next/link'
import { Trans } from '@lingui/macro'
import { Bar, BarItem, Grid, GridCol, Badge } from '../../ui-kit'
import { formatDate } from '../../utils/format'
import { URLS } from '../../../config/constants'

const Article: React.FC<{
  article: CMS.Article
  articlesCategories: CMS.ArticleCategory[]
}> = observer(({ article, articlesCategories }) => {
  const category = articlesCategories.find(i => i.id === article.article_category_id)

  return (
    <GridCol key={article.id} size={{ m: 4 }} className="mb-large">
      <Link href={URLS.articleDetail({ slug: article.slug! })}>
        <a>
          <img
            src={article.images.cover!['1x']}
            style={{ height: 240 }}
            alt={article.title}
            className="mb img--fluid"
          />
          <Bar space="small">
            <BarItem isFilling>
              <p>{formatDate(article.published_at!)}</p>
            </BarItem>
            {category && (
              <BarItem>
                <Badge color={category.color === 'default' ? undefined : category.color}>
                  <span className="text-transform-upper text-bold text-color-white">
                    {category.title}
                  </span>
                </Badge>
              </BarItem>
            )}
          </Bar>
          <h2 className="h5 mb-small">{article.title}</h2>
          <p dangerouslySetInnerHTML={{ __html: article.perex! }} />
          <span className="link text-semibold" style={{ fontSize: '14px' }}>
            <Trans>Prečítať novinku</Trans>
          </span>
        </a>
      </Link>
    </GridCol>
  )
})

export const News: React.FC<{
  articles: CMS.Article[]
  articlesCategories: CMS.ArticleCategory[]
}> = observer(({ articles, articlesCategories }) => {
  return (
    <React.Fragment>
      <h3 className="h6 label mb-xlarge">
        <Trans>Naše novinky</Trans>
      </h3>
      <Grid>
        {articles.map(article => (
          <Article key={article.id} article={article} articlesCategories={articlesCategories} />
        ))}
      </Grid>
    </React.Fragment>
  )
})
